import React from 'react';
import { IProps } from './type';

const DoneRingIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5 10.375L13.0002 12.3804C13.4281 12.7236 14.0525 12.658 14.3998 12.2335L19.5 6"
        stroke={strokeColor ? strokeColor : "#666666"}
        strokeLinecap="round" />
      <path
        d="M20.5 12C20.5 13.6715 19.9764 15.3011 19.0028 16.6598C18.0291 18.0185 16.6544 19.0381 15.0715 19.5754C13.4887 20.1127 11.7773 20.1407 10.1777 19.6555C8.57815 19.1703 7.17075 18.1962 6.15317 16.8701C5.1356 15.544 4.55897 13.9324 4.50428 12.2618C4.44959 10.5911 4.91958 8.94528 5.84824 7.55544C6.7769 6.1656 8.11759 5.10156 9.682 4.51275C11.2464 3.92395 12.956 3.83997 14.5706 4.27259"
        stroke={strokeColor ? strokeColor : "#666666"}
        strokeLinecap="round" />
    </svg>

  )
};

export default DoneRingIcon;
